import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TaskPane from './components/outlook/TaskPane';
import Bridge from './components/outlook/Bridge';

// Office.js is guaranteed to be initialized before React renders
// because main.jsx wraps ReactDOM.render inside Office.onReady().
// No retry loop or readiness checks needed here.
export default function OutlookApp() {
  return (
    <Routes>
      <Route path="taskpane" element={<TaskPane />} />
      <Route path="bridge" element={<Bridge />} />
    </Routes>
  );
}
